import Marquee from "react-fast-marquee";

const ITEMS = ["Your Quality Shopping Partner", "Adding Value to Life", "Rooted in Kerala", "Since 1998"];

export const BrandMarquee = () => (
  <section className="bg-konattu-cream border-y border-konattu-charcoal/10 py-8 md:py-12 overflow-hidden" data-testid="brand-marquee">
    <Marquee speed={40} gradient={false} autoFill>
      {ITEMS.map((t, i) => (
        <div key={i} className="flex items-center">
          <span className="font-display font-extrabold text-stroke-dark text-5xl md:text-7xl lg:text-8xl tracking-tightest px-8">
            {t}
          </span>
          <span className="text-konattu-red text-4xl md:text-6xl px-2">•</span>
        </div>
      ))}
    </Marquee>
  </section>
);

export default BrandMarquee;
